const AUTO_APPLY_STORAGE_KEY = 'ai-mate-auto-apply-enabled';

/**
 * Get the current auto-apply state from localStorage
 */
export function getAutoApplyState(): boolean {
	try {
		const stored = window.localStorage.getItem(AUTO_APPLY_STORAGE_KEY);
		return stored !== null ? JSON.parse(stored) : true;
	} catch {
		return true; // fallback to default
	}
}

/**
 * Set the auto-apply state in localStorage
 */
export function setAutoApplyState(enabled: boolean): void {
	try {
		window.localStorage.setItem(AUTO_APPLY_STORAGE_KEY, JSON.stringify(enabled));
	} catch {
		// Silently fail if localStorage is unavailable
	}
}

/**
 * Toggle the auto-apply state
 */
export function toggleAutoApplyState(): boolean {
	const currentState = getAutoApplyState();
	const newState = !currentState;
	setAutoApplyState(newState);
	return newState;
}
